import { COLUMNS, data } from './partten';
export default {
  data() {
    return {
      form: {},
      COLUMNS,
      organizationlist: [{
        id: '1',
        name: '泛华保险服务集团'
      }],
      data,
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: data.length,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      }
    };
  },
  methods: {
    getDataFun() {},
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    handleExport(val) {
      console.log(val);
      window.location.href = 'http://test.home.console.insurforce.cn/excel/' + this.$t('人身险业务报表') + '.xlsx';
    }
  }
};